window.addEventListener("load", () => {
  const init = function () {
    const snizeButtons = document.querySelectorAll(".snize-button");
    const snizeVariants = document.querySelectorAll(
      ".snize-size:not(.snize-size-unavailable)"
    );
    const snizeSizeBoxes = document.querySelectorAll(".snize-size-select-box");
    const formSnippet = `<form method="post" action="/cart/add" id="product-form-{{productVariantId}}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" style="display: {{display}}">
      <input type="hidden" name="form_type" value="product" tabindex="0">
      <input type="hidden" name="utf8" value="✓" tabindex="0">
      <input type="hidden" name="id" value="{{productVariantId}}" tabindex="0">
      <div class="product-form__buttons">
        <button type="submit" name="add" class="availabe-btn snz-Snize_Button add_to_cart_product_page product-form__submit button button--full-width button--primary" tabindex="0">
          Add to cart
        </button>
        <span type="button" style="cursor: not-allowed" class="soldout-btn button button--full-width button--primary" tabindex="0">
          Out of stock
        </span>

        <div class="qtydiv" style="display: none;">
          <div class="snz-Snize_Quantity qtybox">
            <button class="snz-Snize_Quantity-button btnqty qtyminus icon icon-minus decrease" type="button" tabindex="0"></button>
            <input class="snz-Snize_Quantity-amount quantity-selector quantity-input" type="text" name="quantity" value="" min="1" data-variant-id="{{productVariantId}}" data-min="1" data-cart-quantity="1" readonly="" tabindex="0">
            <button class="snz-Snize_Quantity-button btnqty qtyplus icon icon-plus increase" type="button" tabindex="0"></button>
          </div>
        </div>
      </div>
    </form>`;

    snizeButtons.forEach((button) => {
      const snizeItem = button.closest("li");
      const snizeItemId = snizeItem.id;

      const productId = snizeItemId.replace("snize-product-", "");
      const productVariantId = snizeItem.getAttribute("data-product-variant");
      const snizeSizes = snizeItem.querySelectorAll(
        ".snize-size:not(.snize-size-unavailable)"
      );

      const addToCartElement = document.createElement("div");
      addToCartElement.classList.add("addToCart");
      addToCartElement.classList.add("snz-Snize_Actions");
      let display = "block";
      let snizeSizesHTML = formSnippet
        .replaceAll("{{productVariantId}}", productVariantId)
        .replace("{{display}}", display);

      if (snizeSizes.length > 1) {
        snizeSizesHTML = "";
        display = "none";
        snizeSizes.forEach((size, index) => {
          snizeSizesHTML += formSnippet.replace("{{display}}", display);
        });
      }

      const appElement =
        `
        <div class="product-page-review-wrapper">
          <div class="loox-rating" data-fetch data-id="` +
        productId +
        `" data-rating="{{ product.metafields.loox.avg_rating }}" data-raters="{{ product.metafields.loox.num_reviews }}" data-pattern="[rating] ([count])"></div>
        </div>
        ${snizeSizesHTML}
      `;

      addToCartElement.innerHTML = appElement;

      button.after(addToCartElement);
      button.remove();

      // this could probably be done above, but trying not to change too much
      // can only do this here for products with no variants, because variant IDs for other sizes aren't known yet
      if (snizeSizes.length < 2) {
        // set qty selector value equal to what's in the sidecart so that when the page first loads the right amount is shown
        var selector =
          "#minicart-content-wrapper input.cart-item-qty[data-variant-id='" +
          productVariantId +
          "']";
        var cartQty = document.querySelector(selector);
        if (cartQty) {
          addToCartElement.querySelector(".quantity-input").value =
            cartQty.value;
          addToCartElement.querySelector(".qtydiv").removeAttribute("style");
          addToCartElement
            .querySelector("button[type='submit']")
            .setAttribute("style", "display: none;");
        }
      }

      snizeItem.querySelectorAll(".increase, .decrease").forEach((button) => {
        button.addEventListener("click", (event) => {
          const quantity = snizeItem
            .querySelector(".qtydiv")
            .querySelector(".quantity-input").value;
          const quantityInput = snizeItem.querySelector(".quantity-input");
          const variantId = quantityInput.getAttribute("data-variant-id");
          CartJS.updateItemById(variantId, quantity, {}, {});
        });
      });
    });

    snizeVariants.forEach((variant) => {
      const productLink = variant.closest(".snize-view-link");
      const productVariants = productLink.querySelectorAll(
        ".snize-size:not(.snize-size-unavailable)"
      );
      const index = Array.from(productVariants).indexOf(variant);
      const forms = productLink.querySelectorAll("form");
      const form = forms[index];
      const submitButtons = productLink.querySelectorAll(".snz-Snize_Button");
      const submitButton = form.querySelector(".snz-Snize_Button");
      const quantityInput = form.querySelector(".quantity-input");
      var quantity = quantityInput.value;
      const idInput = form.querySelector('input[name="id"]');
      const productURL = `${productLink.href}.json`;
      const variantTitle = variant.dataset.value;

      variant.addEventListener("click", async (event) => {
        let variantId;

        if (!variant.dataset.variantId) {
          submitButtons.forEach((button) => {
            button.disabled = true;
          });

          const productInfo = await fetch(productURL).then((response) =>
            response.json()
          );
          const { variants } = productInfo.product;
          const foundVariantId = variants.find(
            (variant) => variant.title === variantTitle
          ).id;

          variant.dataset.variantId = foundVariantId;
          submitButton.disabled = false;
        }

        submitButton.disabled = false;
        variantId = variant.dataset.variantId;

        // set qty selector value equal to what's in the sidecart so that when the page first loads the right amount is shown
        var selector =
          "#minicart-content-wrapper input.cart-item-qty[data-variant-id='" +
          variantId +
          "']";
        var cartQty = document.querySelector(selector);
        if (cartQty) {
          quantityInput.value = cartQty.value;
          quantity = cartQty.value;

          $(quantityInput).closest(".qtydiv").attr("style", "display: block;");
        }

        if (quantity > 1) submitButton.style.display = "none";

        form.setAttribute(
          "id",
          form.getAttribute("id").replaceAll("{{productVariantId}}", variantId)
        );
        forms.forEach((form) => {
          form.style.display = "none";
        });
        form.style.display = "block";
        quantityInput.dataset.variantId = variantId;
        idInput.value = variantId;
      });
    });

    snizeSizeBoxes.forEach((sizeBox) => {
      const snizeInactiveVariants = sizeBox.querySelectorAll(
        ".snize-size-active.snize-size-unavailable"
      );

      if (snizeInactiveVariants.length > 0) {
        const firstAvailable = sizeBox.querySelector(
          ".snize-size:not(.snize-size-unavailable)"
        );

        if (firstAvailable) {
          firstAvailable.click();
        } else {
          const snizeProductDetails = sizeBox.parentElement.parentElement;
          const snizeSubmitButton =
            snizeProductDetails.querySelector(".snz-Snize_Button");

          snizeSubmitButton.disabled = true;
          snizeSubmitButton.innerHTML = "Out of Stock";
        }
      }
    });

    // Fix for sort by dropdown not displaying default value.
    const sortByDropdown = document.querySelector(
      ".snize-main-panel-dropdown-button span"
    );
    const sortByCurrentSelection = document.querySelector(
      ".snize-main-panel-dropdown-content li .current"
    );

    if (sortByCurrentSelection) {
      var sortByText = sortByCurrentSelection.textContent;
      sortByDropdown.innerHTML = sortByText;
    } else {
      const sortByDropdownDefault = document.querySelector(
        ".snize-main-panel-dropdown-sales_amount-desc"
      );
      console.log(sortByDropdownDefault);
      var sortByText = sortByDropdownDefault.textContent;

      sortByDropdown.innerHTML = sortByText;
    }

    // Customised Pagination Look
    const paginationPrevious =
      document.querySelector(".snize-pagination-prev") || false;
    const paginationNext =
      document.querySelector(".snize-pagination-next") || false;

    if (paginationNext || paginationPrevious) {
      paginationPrevious.innerHTML = "Previous";
      paginationNext.innerHTML = "Next";
    }
  };

  init();

  window.addEventListener("resize", () => {
    init();
  });

  let oldHref = document.URL;
  const bodyList = document.querySelector("body");
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (oldHref !== document.URL) {
        oldHref = document.URL;
        init();
      }
    });
  });

  const config = {
    childList: true,
    subtree: true,
  };

  observer.observe(bodyList, config);
});
